<template>
  <vk-modal
      :is-open="isOpen"
      :has-close-icon="closeIcon"
      @close="$emit('close')">
    <vk-modal-body>
      <vk-modal-header :class="['bd-b-gray40', { 'p-l-6': closeIcon } ]" class="text-center c-gray60">
        <span>{{title}}</span>
      </vk-modal-header>
      <vk-modal-content class="d-flex fd-column p-0">
        <div class="bg-white">
          <div class="d-flex p-4:d">
            <img
                class="as-center w-100"
                :src="image"
            />
          </div>
        </div>
      </vk-modal-content>
      <vk-modal-footer class="d-flex jc-end w-100">
        <div>
          <button @click="$emit('close')" class="m-t-2 p-x-4 m-x-auto btn">
            {{cta}}
          </button>
        </div>
      </vk-modal-footer>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
import SlidingModal from '@/views/Dashboard/components/SlidingModal';

export default {
  name: 'checklist-modal',
  components: {
    SlidingModal,
  },
  props: {
    isOpen: Boolean,
    modal: {
      type: Object,
      required: true,
    },
    closeIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    image () {
      return this.modal.fields.image.fields.file.url;
    },
    title () {
      return this.modal.fields.title;
    },
    cta () {
      return this.modal.fields.cta;
    },
  },
};
</script>
